import axios from './axios'

export const summary = (params) => axios.get('/management/order/statistics', { params })
export const queryByDay = params => axios.get('/management/order/statistics/day', { params })
export const queryByUser = params => axios.get('/management/order/statistics/user', { params })
